import { render, staticRenderFns } from "./news_list.vue?vue&type=template&id=ea278aa4&scoped=true"
import script from "./news_list.vue?vue&type=script&lang=js"
export * from "./news_list.vue?vue&type=script&lang=js"
import style0 from "./news_list.vue?vue&type=style&index=0&id=ea278aa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea278aa4",
  null
  
)

export default component.exports